import ReactECharts from "echarts-for-react";
import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "states/DashboardContext";

function ShuleSekondariKwaMikoa() {
  const hook = useShuleSekondariKwaMikoa();
  const words = useTranslations();

  const options = {
    title: {
      text: `${words.chartTitle}`,
      textStyle: {
        fontSize: "20",
      },
    },
    maintainAspectRatio: false,
    grid: {
      containLabel: true,
      left: "9%",
      bottom: "0%",
      right: "5%",
      top: "10%",
    },
    tooltip: { trigger: "axis" },
    toolbox: {
      show: true,
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    dataZoom: [
      { show: false },
      { type: "inside" },
      {
        show: false,
        yAxisIndex: 10,
        filterMode: "empty",
        width: 30,
        height: "70%",
        showDataShadow: false,
        left: "93%",
      },
    ],
    xAxis: {
      type: "category",
      data: ((regions) => {
        const dt = regions.map((region) => {
          return region.name;
        });
        return dt;
      })(hook.regionData),
      axisLabel: {
        show: true,
        interval: 0,
        rotate: 90,
        fontSize: "16",
        fontWeight: "bold",
      },
    },
    yAxis: [
      {
        type: "value",
        nameLocation: "middle",
        nameGap: 50,
        axisLabel: {
          formatter: "{value}",
          show: true,
          interval: 0,
          rotate: 0,
          fontSize: "16",
          fontWeight: "800",
        },
      },
    ],
    series: [
      {
        type: "bar",
        name: "",
        barMaxWidth: 20,
        data: ((regions) => {
          const regionCounts = regions.map((region) => region.value);
          const dt = regionCounts.map((count, index) => {
            return {
              value: count,
              itemStyle: {
                color: "#1985A1",
              },
            };
          });
          return dt;
        })(hook.regionData),
      },
    ],
  };
  return (
    <div className="h-full text-[1.5vw] flex items-center justify-center">
      <div className="relative flex flex-col items-center justify-center w-full h-full gap-2">
        {hook.regionData && (
          <ReactECharts
            style={{ height: "80vh", minHeight: 200, width: "100%" }}
            option={options}
          />
        )}
      </div>
    </div>
  );
}

export default ShuleSekondariKwaMikoa;

const useTranslations = () => {
  const { languageState } = useContext(DashboardContext);
  const [language] = languageState;

  return {
    chartTitle: language
      ? "Number of Sekondary Schools by region"
      : "Idadi ya Shule za Sekondari kwa Mikoa",
    chartYAxis: language ? "Number in 100,000" : "Idadi kwa 100,000",
    language,
  };
};

const useShuleSekondariKwaMikoa = () => {
  const censusYears = [1967, 1978, 1988, 2002, 2012, 2022];
  const lastIndex = censusYears.length - 1;
  const [selectedYearIndex, setSelectedYearIndex] = useState(lastIndex);
  const censusYear = censusYears[selectedYearIndex];
  const previousCensusYear = censusYears[selectedYearIndex - 1] ?? null;
  const nextCensusYear = censusYears[selectedYearIndex + 1] ?? null;

  // year change handlers
  const handleNext = () => {
    if (selectedYearIndex === lastIndex) return;
    setSelectedYearIndex((prev) => prev + 1);
  };

  const handlePrevious = () => {
    if (selectedYearIndex === 0) return;
    setSelectedYearIndex((prev) => prev - 1);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const _data = regionDataGenerator(censusYear);
    setData((prev) => {
      prev = _data;
      return prev;
    });
  }, [selectedYearIndex]);

  return {
    regionData: data,
    selectedYearIndex,
    lastIndex,
    handleNext,
    handlePrevious,
    censusYear,
    previousCensusYear,
    nextCensusYear,
  };
};

const regionDataGenerator = (year) => {
  return [
    { name: "Dodoma", value: 233  },
    { name: "Arusha", value: 269},
    { name: "Kilimanjaro", value: 349 },
    { name: "Tanga", value: 298  },
    { name: "Morogoro", value: 281 },
    { name: "Pwani", value: 219 },
    { name: "Dar es Salaam", value: 350 },
    { name: "Lindi", value: 133 },
    { name: "Mtwara", value: 165 },
    { name: "Ruvuma", value: 217 },
    { name: "Iringa", value: 191 },
    { name: "Mbeya", value: 266 },
    { name: "Singida", value: 167 },
    { name: "Tabora", value: 212 },
    { name: "Rukwa", value: 97 },
    { name: "Kigoma", value: 219},
    { name: "Shinyanga", value: 172 },
    { name: "Kagera", value: 287 },
    { name: "Mwanza", value: 330 },
    { name: "Mara", value: 266 },
    { name: "Manyara", value: 183 },
    { name: "Njombe", value: 139 },
    { name: "Katavi", value: 62 },
    { name: "Simiyu", value: 167 },
    { name: "Geita", value: 190 },
    { name: "Songwe", value: 130 },
    { name: "Kaskazini Unguja", value: 39 },
    { name: "Kusini Unguja", value: 45 },
    { name: "Mjini Magharibi", value: 84 },
    { name: "Kaskazini Pemba", value: 46 },
    { name: "Kusini Pemba", value: 51 },
  ].sort((a, b) => (a.value < b.value ? 1 : -1));
};
